module.exports = __webpack_public_path__ + "img/電気回路_3_7.6de4aed6.png";